export const getFlowQuestions = (survey_template) =>  {
    return survey_template.flowedQuestions || survey_template.questions
}
